import { SVGProps } from 'react';

export const IconBucket = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 24 24' {...props}>
      <path
        d='M17.5116 17.4955L18.9609 16.0439L20.4101 17.4955C21.2106 18.2972 21.2106 19.597 20.4101 20.3987C19.6097 21.2004 18.312 21.2004 17.5116 20.3987C16.7111 19.597 16.7111 18.2972 17.5116 17.4955ZM9.02687 3L18.3024 12.2903C18.6225 12.611 18.6225 13.1309 18.3024 13.4516L11.3457 20.4193C11.0256 20.74 10.5064 20.74 10.1863 20.4193L3.22966 13.4516C2.90949 13.1309 2.90949 12.611 3.22966 12.2903L9.60659 5.90323L7.86743 4.1613L9.02687 3ZM10.766 7.06452L4.96882 12.8709H16.5632L10.766 7.06452Z'
        fill='currentColor'
      />
    </svg>
  );
};
